var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 -35 100 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50.912,0 61.094,10.182 27.563,43.712 86.4,43.712 86.4,58.111 27.564,58.111 61.094,91.641 50.912,101.823  0,50.912 ",
    fill: "#105290"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfArrowLeft);
export default __webpack_public_path__ + "static/media/AFArrow_left.961f5b4bfeb0646c190969f35743f2c9.svg";
export { ForwardRef as ReactComponent };